import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "juou-card" }

import {
  useBaseAsync,
  type HpsfirProTableColumn,
  type HpsfirProTableData,
  type HpsfirProTableFilter,
  type HpsfirProTableGetDataFunction,
  type HpsfirProFormItem,
} from 'hpsfir-managebase-ui';

import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';
import dayjs from 'dayjs';
import { normalizeBizTableColumns } from '@/utils/tableColumns';

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const columns = ref<HpsfirProTableColumn[]>(normalizeBizTableColumns([]));
const tableRef = ref<any>();


const addInitValue = {

};
const conditionsInitValue = {
};


let adminOptions = ref<{
  value: any;
  label: string;
}[]>([]);
// eslint-disable-next-line max-lines-per-function
const init = useBaseAsync(async() => {
  const res = await useApi().adminApi.listAdminadmin({ conditions: {} });
  console.log(res);
  adminOptions.value
    = res.data.data?.map((item: any) => ({
      value: item.id,
      label: `${item.name}`,
    })) || [];
  columns.value = normalizeBizTableColumns([
    {
      name: 'name',
      label: '服务商姓名',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'phone',
      label: '服务商电话',
      type: 'string',
      isCondition: true,
      rule: [{ required: true }],
    },
    {
      name: 'password',
      label: '登录密码',
      type: 'password',
      rule: [{ required: true }],
    },
    {
      name: 'province',
      label: '服务省份',
      type: 'string',
      rule: [{ required: true }],
    },
    {
      name: 'city',
      label: '服务市',
      type: 'string',
      rule: [{ required: true }],
    },
    {
      name: 'createTime',
      label: '加入时间',
      type: 'string',
      width: 80,
      hideCreate: true,
      hideEdit: true,
      render: (scope: any) => (scope?.row?.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss') : ''),
    },
    {
      name: 'deviceCount',
      label: '铺设设备',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },
    {
      name: 'relativeId',
      label: '跟进人员',
      type: 'searchSelect',
      options: adminOptions.value,
      hideTable: true,
    },
    {
      name: 'relativeName',
      label: '跟进人员',
      type: 'string',
      hideCreate: true,
      hideEdit: true,
    },

  ]);
});

const operates: any[] = [];

const loading = ref(false);


const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().facilitatorApi.pageFacilitatorfacilitator({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }
        conditions[key] = val;
        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },


    });
    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您正在进行删除(${row.idHex})操作，请谨慎操作`;


const addFun = useBaseAsync(async(data: any) => {
  if (data.relativeId) {
    data.relativeName = adminOptions.value.find((item: any) => item.value === data.relativeId)?.label;
  }
  await useApi().facilitatorApi.addFacilitatorfacilitator({
    facilitatorAdminVo: data,
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  if (data.relativeId) {
    data.relativeName = adminOptions.value.find((item: any) => item.value === data.relativeId)?.label;
  }
  await useApi().facilitatorApi.updateFacilitatorfacilitator({
    facilitatorAdminVo: data,
  });
  ElMessage.success('修改成功');
});
const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().facilitatorApi.delFacilitatorfacilitator(data.id);
  ElMessage.success('删除成功');
});


init();


return (_ctx: any,_cache: any) => {
  const _component_HpsfirProTable = _resolveComponent("HpsfirProTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HpsfirProTable, {
      ref_key: "tableRef",
      ref: tableRef,
      "export-file-name": "服务商",
      title: "服务商",
      paginations: { pageSize: 10 },
      columns: columns.value,
      "get-data": _unref(getData),
      "on-add": _unref(addFun),
      "on-delete": _unref(deleteFun),
      "on-edit": _unref(updateFun),
      loading: loading.value,
      "is-dangder-delete": true,
      "format-dangder-delete-info": formatDeleteInfo,
      "row-key": "id",
      operates: operates,
      "add-init-values": addInitValue,
      "codition-init-values": conditionsInitValue
    }, null, 8, ["columns", "get-data", "on-add", "on-delete", "on-edit", "loading"])
  ]))
}
}

})